export const MODEL_SIZE = 512;

export type PreparedImage = {
  width: number;
  height: number;
  original: Uint8ClampedArray;
  modelInput: Uint8ClampedArray;
};

function canvas2d(width: number, height: number) {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (!context) throw new Error("This browser cannot create a 2D image canvas.");
  return { canvas, context };
}

export async function prepareImage(file: File): Promise<PreparedImage> {
  const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  const width = bitmap.width;
  const height = bitmap.height;

  if (!width || !height) {
    bitmap.close();
    throw new Error("The image has no readable pixels.");
  }

  const full = canvas2d(width, height);
  full.context.drawImage(bitmap, 0, 0);
  const original = full.context.getImageData(0, 0, width, height).data;

  const model = canvas2d(MODEL_SIZE, MODEL_SIZE);
  model.context.drawImage(bitmap, 0, 0, MODEL_SIZE, MODEL_SIZE);
  const modelInput = model.context.getImageData(0, 0, MODEL_SIZE, MODEL_SIZE).data;
  bitmap.close();

  return { width, height, original, modelInput };
}

export async function pixelsToPng(
  pixels: Uint8ClampedArray,
  width: number,
  height: number,
): Promise<Blob> {
  const { canvas, context } = canvas2d(width, height);
  const imageData = context.createImageData(width, height);
  imageData.data.set(pixels);
  context.putImageData(imageData, 0, 0);

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("The protected PNG could not be created."));
    }, "image/png");
  });
}

export function protectedFilename(originalName: string) {
  const stem = originalName.replace(/\.[^.]+$/, "") || "artwork";
  return `${stem}-veiled.png`;
}
